import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// *************** 校区管理 *************** //

// 校区信息
export const campusList = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/list',
    method: 'post'
  })
}
// 省市区
export const getAddrData = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/common/area/tree',
    method: 'post'
  })
}
// 获取小程序tab
export const getNavigationBarsList = () => {
  return fetch({
    url: '/api-manager/organize/campus/getNavigationBars',
    method: 'post'
  })
}
// 校区信息
export const campusInfo = (campusId:number) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/info',
    method: 'post',
    data: {
      campusId
    }
  })
}
// 校区新增
export const campusAdd = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/add',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 校区编辑
export const campusEdit = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/edit',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 校区删除
export const campusDel = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/delete',
    method: 'post'
  })
}
// 校区停/启用
export const campusToggleEnable = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/campus/enable',
    method: 'post',
    data: {
      ...params
    }
  })
}
